import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class ListofvaluesService {

  constructor(private http: HttpClient) { }

  getLdvByCode(code) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/list-of-values/'+code, { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/listofvalues.service.ts